import { isCorn } from './isCorn.js';
import { getCornKernels } from './getCornKernels.js';
export const getResourceId = (id) => (isCorn(id) ? getCornKernels(id).resourceId : id);
